<template>

    <div>

        <settingsNav></settingsNav>
        <v-container>

            <!--        <v-layout row v-if="getNetworkError">
                        <v-flex xs12>
                            <app-alert @dismissed="onDismissedError" :text="getNetworkError.message"></app-alert>
                        </v-flex>
                    </v-layout>-->

            <v-layout row wrap>

                <v-flex xs12 sm12 mb-2>

                    <v-btn class="secondary white--text" @click.stop="openCustomerDialog(null)">
                        New Customer
                        <v-icon class="white--text" right>add</v-icon>
                    </v-btn>

                </v-flex>

            </v-layout>

            <v-layout row wrap>

                <v-flex xs12 sm12>
                    <v-layout row>
                        <v-flex xs12>
                            <v-card>
                                <v-card-title>
                                    <v-card-title class="headline">
                                        Customers
                                    </v-card-title>
                                    <v-spacer></v-spacer>
                                    <v-text-field
                                            v-model="search"
                                            append-icon="search"
                                            label="Search"
                                            single-line
                                            hide-details
                                            clearable
                                    ></v-text-field>
                                </v-card-title>

                                <v-data-table
                                        :headers="headers"
                                        :items="getCustomers"
                                        :pagination.sync="pagination"
                                        :total-items=total
                                        class="elevation-0"
                                        :loading="loading"
                                        :rows-per-page-items="rowsPageItems"
                                >

                                    <template slot="headerCell" slot-scope="props">
                                        <v-tooltip bottom>
                                        <span slot="activator">
                                          {{ props.header.text }}
                                        </span>
                                            <span>
                                          {{ props.header.text }}
                                        </span>
                                        </v-tooltip>
                                    </template>
                                    <template slot="items" slot-scope="props">
                                      <v-touch tag="tr"
                                               @doubletap="openCustomerDialog(props.item.id)"
                                               @dblclick="openCustomerDialog(props.item.id)">
                                            <td>{{ props.item.id }}</td>
                                            <td class="text-xs-left">{{ props.item.name }}</td>
                                            <td class="text-xs-left">{{ props.item.website }}</td>
                                            <td class="text-xs-left">{{ props.item.email }}</td>
                                      </v-touch>
                                    </template>
                                </v-data-table>
                            </v-card>
                        </v-flex>

                    </v-layout>


                    <addCustomerDialog></addCustomerDialog>


                </v-flex>
            </v-layout>

        </v-container>
    </div>


</template>

<script>
    import {
        Settings,
        Customer
    } from '../../store/namespace-helper'
    import addCustomerDialog from '../Customers/AddCustomerDialog.vue'
    import settingsNav from '../Shared/SettingsNav.vue'
    import {stateHelperMixin} from '../../mixins/stateHelperMixin'
    import _ from 'lodash'

    export default {
      name: 'customers',
      components: {
        addCustomerDialog,
        settingsNav
      },
      mixins: [stateHelperMixin],
      data () {
        return {
          isVisible: false,
          headers: [
                    {text: 'Customer-ID', value: 'id'},
                    {text: 'Company Name', value: 'name'},
                    {text: 'Website', value: 'website'},
                    {text: 'E-Mail', value: 'email'}
          ],
          pagination: {},
          search: '',
          total: 0,
          onDismissed: false,
          rowsPageItems: [10, 25, 50, 100, 250]
        }
      },
      beforeDestroy () {
        this.resetStateBeforeLeaveRoute()
      },
      mounted () {
        this.loadCustomers()
      },
      methods: {
        openCustomerDialog (val) {
          if (val !== null) {
            let item = this.getCustomers.find(x => x.id === val)
            this.$store.dispatch(Customer.actions.setSelectedCustomer, item)
          }
          this.$store.dispatch(Customer.actions.openCloseNewCustomerDialog)
        },
        loadCustomers: function () {
          const {sortBy, descending, page, rowsPerPage} = this.pagination
          const query = {
            sortBy: sortBy || 'id',
            descending: descending ? 'desc' : 'asc',
            page: page || 1,
            limit: rowsPerPage !== -1 ? rowsPerPage : 0,
            search: this.search ? this.search : ''
          }
          this.$store.dispatch(Customer.actions.loadCustomers, query)
        },
        throttledLoadCustomers: _.debounce(function () {
          this.loadCustomers()
        }, 450)
      },
      computed: {
        getCustomers () {
          this.total = this.$store.getters[Customer.getters.customers].total
          return this.$store.getters[Customer.getters.customers].data
        },
        dialogState () {
          return this.$store.getters[Customer.getters.getOpenNewCustomerDialogState]
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        getNetworkError () {
          return this.$store.getters[Settings.getters.getNetworkError]
        }
      },
      watch: {
        pagination: {
          handler () {
            this.loadCustomers()
          },
          deep: true
        },
        search: {
          handler (val) {
            this.throttledLoadCustomers()
          },
          deep: true
        },
        dialogState: {
          handler (val) {
            if (!val) {
              // reload customer list
              this.throttledLoadCustomers()
            }
          },
          deep: true
        }
      }

    }
</script>

<style scoped>

    th:focus {
        outline: none !important;
    }

</style>



// WEBPACK FOOTER //
// src/components/Customers/Customers.vue